/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { isEmpty } from 'lodash';
import Radio from '../../../../components/fields/Radio';
import messages from '../../../../views/messages/searchFlightForm';
import DepartureIcon from '../../../../assets/icons/departure-icon.inline.svg';
import ArrivalIcon from '../../../../assets/icons/arrival-icon.inline.svg';
import { Form, Formik } from 'formik';
import { useIntl } from 'react-intl';
import AirportSelect, {
  airportSelectMessages,
} from '../../../../components/fields/AirportSelect';
import AirlineSelect from '../../../../components/fields/AirlineSelect';
import Input from '../../../../components/fields/Input';
import { useHandleError, jsonApiAxios } from '../../../../services/api';
import useAuthenticate from '../../../../hooks/useAuthenticate';
import DatePicker from '../../../../components/fields/DatePicker';
import EnterConnectingFlights from './EnterConnectingFlights';
import { useTranslatedNavigate } from '../../../../utils/routes';
import translations from '../../../../translations/main.json';
// import Datetime from 'react-datetime';
import FlightsPage from '../UploadDocument/FlightsPage';

const subscriptionTripsSchema = {
  attributes: ['file', 'subscriptionFlights'],
  file: {
    ref: 'id',
  },
};

const subscriptionFlightsSchema = {
  attributes: [
    'subscriptionTrip',
    'flight_code',
    'flight_date',
    'departureAirport',
    'airline',
    'arrivalAirport',
    'status',
  ],
  subscriptionTrip: {
    ref: 'id',
  },
  departureAirport: {
    ref: 'id',
  },
  airline: {
    ref: 'id',
  },
  arrivalAirport: {
    ref: 'id',
  },
};

const tripSchema = {
  attributes: ['status'],
};

interface Flight {
  flight_code: string;
  flight_date: string;
  departureAirport: {
    id: string;
    iata: string;
  };
  arrivalAirport: {
    id: string;
    iata: string;
  };
  airline: {
    id: string;
    name: string;
  };
}

const FindSingleFlight = (props: any) => {
  // const dayAfterTomorrow = Datetime.moment()
  //   .add(1, 'days')
  //   .startOf('day');
  // const valid = current => {
  //   return current.isAfter(dayAfterTomorrow);
  // };

  const {
    isReturnFlight,
    setIsReturnFlight,
    setIsFlightPage,
    departureFlight,
    setDepartureFlight,
    setReturnFlight,
    setTripId,
    tripId,
    setTripsArray,
    tripsArray,
  } = props;
  const [connectionType, setConnectionType] = useState('direct');
  const [hasReturnFlight, setHasReturnFlight] = useState(true);
  const [initialValues, setInitialValue] = useState({});
  const [showFlightComponent, setShowFlightComponent] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [flights, setFlights] = useState([]);
  const [storeFlights, setStoreFlights] = useState([]);
  const [flightData, setFlightsData] = useState<any[]>([]);
  const [flightsToSave, setFlightsToSave] = useState<any[]>([]);
  const { token } = useAuthenticate();
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const translatedNavigate = useTranslatedNavigate();
  const [handleError] = useHandleError();

  const { formatMessage } = useIntl();

  const changeConnectionType = (value: string) => {
    setConnectionType(value);
  };

  const handleSubmit = (values: any, { resetForm }) => {
    if (!hasReturnFlight) {
      setDepartureFlight(values);
      createTrip([values]);
    } else {
      if (isEmpty(departureFlight)) {
        setInitialValue({
          departure_airport: values?.arrival_airport,
          arrival_airport: values?.departure_airport,
          flight_code: '',
          airline: values?.airline,
          connectionType: values?.connectionType,
        });
        setStoreFlights([values]);
        setDepartureFlight(values);
        setIsReturnFlight(true);
        resetForm({});
      } else {
        const updatedFlights = [...storeFlights, values];
        setStoreFlights(updatedFlights);
        createTrip(updatedFlights);
        setReturnFlight(values);
      }
    }
  };

  const createTrip = async (fligtsToAttach: any) => {
    const flightsNumber = !hasReturnFlight ? [1] : [1, 2];
    const promises = flightsNumber.map((item: number) =>
      jsonApiAxios.post(
        '/subscriptionTrips',
        {},
        {
          schema: subscriptionTripsSchema,
          type: 'subscriptionTrips',
          headers,
        }
      )
    );
    return Promise.all(promises).then(async (res: any) => {
      if (res?.length) {
        setTripsArray(res.map((item: any) => item?.id));
        setTripId(res?.[0]?.id);
        const flightValues = fligtsToAttach.map((item: any, index: number) => ({
          subscriptionTrip: { id: res[index]?.id },
          airline: { id: item?.airline },
          arrivalAirport: { id: item?.arrival_airport },
          departureAirport: { id: item?.departure_airport },
          flight_code: item?.flight_code,
          flight_date: item?.departure_date,
        }));
        try {
          // Create an array of promises to attach all flights
          const attachPromises = [];
          for (const values of flightValues) {
            attachPromises.push(attachFiles(values));
          }

          // Wait for all flight attachments to complete
          await Promise.all(attachPromises);

          setIsFlightPage(true);
        } catch (error) {
          handleError(error);
        }
      }
    });
  };

  const createConnectingTrip = async () => {
    const trip = await jsonApiAxios.post(
      '/subscriptionTrips',
      {},
      {
        schema: subscriptionTripsSchema,
        type: 'subscriptionTrips',
        headers,
      }
    );
    if (trip?.id) {
      setTripId(trip?.id);
      setTripsArray([trip?.id]);
      const flightValues = flightData?.[0]?.flights?.map((item: any) => ({
        subscriptionTrip: { id: trip?.id },
        airline: { id: item?.airline?.id },
        arrivalAirport: { id: item?.arrivalAirport?.id },
        departureAirport: { id: item?.departureAirport?.id },
        flight_code: item?.flight_code,
        flight_date: item?.flight_date,
      }));

      try {
        // Create an array of promises to attach all flights
        const attachPromises = [];
        for (const values of flightValues) {
          attachPromises.push(attachFiles(values));
        }

        // Wait for all flight attachments to complete
        await Promise.all(attachPromises);

        setShowFlightComponent(true);
      } catch (error) {
        handleError(error);
      }
    }
  };

  const handleSaveConnectingFlight = async () => {
    if (tripId) {
      const flightValues = flightsToSave?.map((item: any) => ({
        id: item,
        status: 'Approved',
      }));

      await updateFlightStatus(flightValues);
      uppdateTrip();
    }
  };

  const attachFiles = (values: any) => {
    return jsonApiAxios.post('/subscriptionFlights', values, {
      schema: subscriptionFlightsSchema,
      type: 'subscriptionFlights',
      headers,
    });
  };

  const uppdateTrip = async () => {
    return jsonApiAxios
      .patch(
        `/subscriptionTrips/${tripId}`,
        {
          status: 'Active',
        },
        {
          schema: tripSchema,
          type: 'subscriptionTrips',
          headers,
        }
      )
      .then(res => {
        translatedNavigate(
          '/' +
            translations['cc4.seo.route.account'] +
            '/' +
            translations['cc4.seo.route.my-premium']
        );
      });
  };

  const updateFlightStatus = (values: any) => {
    const payload: { 'atomic:operations': any[] } = {
      'atomic:operations': [],
    };
    values?.forEach(value => {
      payload['atomic:operations'].push({
        op: 'update',
        href: `/subscriptionFlights/${value?.id}`,
        data: {
          type: 'subscriptionFlights',
          id: value?.id,
          attributes: {
            status: 'Approved',
          },
        },
      });
    });
    return jsonApiAxios.post('/operations', payload, {
      noSerialize: true,
    });
  };

  const checkValues = values => {
    if (
      !values?.connectionType ||
      !values?.departure_airport ||
      !values?.arrival_airport ||
      !values?.airline ||
      !values?.departure_date ||
      !values?.flight_code
    ) {
      return true;
    }
    return false;
  };

  const validateFlightData = () => {
    if (
      !flightData ||
      !flightData?.[0]?.flights ||
      flightData?.[0].flights.length < 2
    ) {
      return true;
    }

    const requiredFields = [
      'flight_code',
      'flight_date',
      'departureAirport.id',
      'departureAirport.iata',
      'arrivalAirport.id',
      'arrivalAirport.iata',
      'airline.id',
      'airline.name',
    ];

    return flightData[0].flights.some((flight: Flight) => {
      return requiredFields.some(field => {
        const value = field.split('.').reduce((obj, key) => obj?.[key], flight);
        return !value;
      });
    });
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        {({ values }) => (
          <Form>
            {connectionType !== 'connecting' && (
              <Radio
                className="sm:max-w-none max-w-none"
                name="connectionType"
                // eslint-disable-next-line
                onChangeCallback={changeConnectionType}
                options={[
                  {
                    label: messages.connectionTypeLabelDirect,
                    value: 'direct',
                  },
                  {
                    label: messages.connectionTypeLabelConnecting,
                    value: 'connecting',
                  },
                ]}
              />
            )}
            {connectionType === 'direct' ? (
              <>
                <div className="airport-container flex">
                  <AirportSelect
                    name="departure_airport"
                    label={airportSelectMessages.labelDepartureAirport}
                    placeholder={
                      airportSelectMessages.placeholderDepartureAirport
                    }
                    icon={<DepartureIcon />}
                    autoComplete="off"
                    defaultOptions={false}
                    prefillWithFirstOption={false}
                    noClass={true}
                    className="aiport-subscription"
                  />
                  <AirportSelect
                    name="arrival_airport"
                    label={airportSelectMessages.labelArrivalAirport}
                    placeholder={
                      airportSelectMessages.placeholderArrivalAirport
                    }
                    icon={<ArrivalIcon />}
                    autoComplete="off"
                    defaultOptions={false}
                    prefillWithFirstOption={false}
                    noClass={true}
                    className="aiport-subscription"
                  />
                </div>
                <div
                  className="airport-container flex"
                  style={{ marginTop: '24px' }}
                >
                  <AirlineSelect
                    name="airline"
                    autoComplete="off"
                    noClass={true}
                    className="aiport-subscription"
                  />
                  <div className="row-container flex" style={{ gap: '24px' }}>
                    <Input
                      name="flight_code"
                      label={messages.flightNumberLabel}
                      placeholder={messages.flightCodePlaceholder}
                      noClass={true}
                      className="subscription-width-input"
                    />
                    <DatePicker
                      name="departure_date"
                      label={messages.flightDateLabel}
                      autoComplete="off"
                      noClass={true}
                      className="subscription-width-input"
                      // isValidDate={valid}
                    />
                  </div>
                </div>
                {!isReturnFlight && (
                  <div style={{ marginTop: '24px' }}>
                    <input
                      type="checkbox"
                      checked={hasReturnFlight}
                      onChange={() => setHasReturnFlight(!hasReturnFlight)}
                    />
                    <span
                      className="return-flight-label"
                      style={{ marginLeft: '10px' }}
                    >
                      {formatMessage(messages.returnFlightType)}
                    </span>
                  </div>
                )}
                <div style={{ marginTop: '24px' }}>
                  <button
                    className="button-manual-entry"
                    type="submit"
                    disabled={checkValues(values)}
                  >
                    {formatMessage(messages.continueManualFlight)}
                  </button>
                </div>
              </>
            ) : connectionType === 'connecting' && !showFlightComponent ? (
              <>
                <EnterConnectingFlights
                  setFlights={setFlights}
                  setActiveStep={setActiveStep}
                  activeStep={activeStep}
                  setFlightsData={setFlightsData}
                  flightData={flightData}
                />
                <div style={{ marginTop: '24px' }}>
                  <button
                    className="button-manual-entry"
                    type="button"
                    onClick={() => createConnectingTrip()}
                    disabled={validateFlightData()}
                  >
                    {formatMessage(messages.continueManualFlight)}
                  </button>
                </div>
              </>
            ) : (
              <>
                <FlightsPage
                  tripId={tripId}
                  setFlightsToSave={setFlightsToSave}
                  tripsArray={tripsArray}
                />
                <div style={{ marginTop: '24px' }}>
                  <button
                    className="button-manual-entry"
                    type="button"
                    onClick={handleSaveConnectingFlight}
                  >
                    {formatMessage(messages.continueManualFlight)}
                  </button>
                </div>
              </>
            )}
          </Form>
        )}
      </Formik>
      <div id="delegateSubmit" />
    </>
  );
};

export default FindSingleFlight;
